import { GET_SERIES } from '../actions/action.types';

export default (state = [], action) => {
  switch (action.type) {
    case GET_SERIES:
      return action.payload || [];
    default:
      return state;
  }
};
